























import Vue from 'vue'
import AlertBar from '@/components/AlertBar.vue'
export default Vue.extend({
    components: { AlertBar },
    data() {
        return {
            alert: false,
            error: 'The password is not correct.',
            password: null
        }
    },
    computed: {
        adminLabel(): string {
            //  Find our admin
            const admin = this.$store.getters.adminUser

            //  If there is no admin, return nothing
            if (!admin) return null

            //  Else, grab the email from our admin
            const email = admin.email

            //  Return our text with this admin email
            return `${email} is the admin of the account. Contact them for the password.`
        },
        loading(): boolean {
            return this.$store.getters.loading
        },
        tenant_id(): number {
            if (this.$store.getters.tenant) {
                return this.$store.getters.tenant.id
            }
            return this.$store.getters.selectedMembership.tenant_id
        }
    },
    methods: {
        close(): void {
            this.$emit('submit', false)
        },
        async submit(): Promise<boolean> {
            //  Validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Construct payload with password and tenant id
            let pl = { password: this.password, tenant_id: this.tenant_id }

            //  Else, send the password confirm request to the API
            const result = await this.$store.dispatch('authUserConfirm', pl)

            //  Reset the password & validator
            this.password = null
            this.$validator.reset()

            //  If the result failed, pop alert
            if (!result) return (this.alert = true)

            //  Else, emit result to parent component
            this.$emit('submit', true)
        }
    }
})
